import { CompanyDetailModule } from '@/modules/company/company-detail';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  id: z.coerce.string(),
});

export const Route = createFileRoute('/dashboard/companies/$id')({
  params: {
    parse: params => paramsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  component: CompanyDetailPage,
});

function CompanyDetailPage() {
  return <CompanyDetailModule />;
}
